export const dischargeMockData = {
  patientOutcome: "",
  finalDiagnosis: "",
  remark: "",
  dietInstructions: "",
  activityRestrictions: "",
  followUpDate: "",
  ownerInstructions: "",
  dateOfDeath: "",
  timeOfDeath: "",
  circumstances: "",
};

export const AGAINST_DOCTORS_ADVICE =
  "Discharged against doctor's advice at Owner's request";

export const patientOutcomeOptions = [
  AGAINST_DOCTORS_ADVICE,
  "Recovered — Discharged to owner",
  "Transferred to another facility",
  "Deceased",
];
